export const dataLibA = [{
  word: 'an',
  partOfSpeech: 'ART',
  definition: ['a', 'an'],
  egSentenceKw: 'I ni an chimiz wouj.',
  egSentenceEn: 'He has a red shirt.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. un]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'asou',
  partOfSpeech: 'PREP',
  definition: ['on', 'on top of', 'atop', 'upon'],
  egSentenceKw: 'Mété\'y asou tab-la.',
  egSentenceEn: 'Put it on the table.',
  synonym: ['anlè', 'konsèné'],
  antonym: [null],
  etymology: '[< Fr. sur]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'alé',
  partOfSpeech: 'PREP',
  definition: ['to go (to)'],
  egSentenceKw: 'Lè sòlèy kouché, i alé lakay li.',
  egSentenceEn: 'When the sun went down, he went home.',
  synonym: [null],
  antonym: ['vini', 'viwé', 'witounen'],
  etymology: '[< Fr. aller]',
  dialect: '🇱🇨',
  variant: ['ay'],
}, {
  word: 'achté',
  partOfSpeech: 'V',
  definition: ['to buy', 'to purchase'],
  egSentenceKw: 'Nou achté sé chèz-la an lanmen an piti madanm.',
  egSentenceEn: 'We bought the chairs from a small woman.',
  synonym: ['ganyen'],
  antonym: ['vann'],
  etymology: '[< Fr. acheter]',
  dialect: '🇱🇨',
  variant: ['ay'],
}, {
  word: '-a',
  partOfSpeech: 'ART',
  definition: ['the', '(conditioned variant)'],
  egSentenceKw: 'Mwen ni chapo-a.',
  egSentenceEn: 'I have the hat.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: ['-an', '-la', '-lan'],
}, {
  word: '-an',
  partOfSpeech: 'ART',
  definition: ['the', '(conditioned variant)'],
  egSentenceKw: 'Mété mwen bò pon-an.',
  egSentenceEn: 'Let me out at the bridge.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: ['-a', '-la', '-lan'],
}, {
  word: 'akennsin',
  partOfSpeech: 'N',
  definition: ['type of freshwater fish'],
  egSentenceKw: 'La ni an chay akennsin an ma-a ki dèyè faktri-a.',
  egSentenceEn: 'There are lots of akennsin in the pond behind the factory.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. Atkinson]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'amèn',
  partOfSpeech: 'INTERJ',
  definition: ['amen'],
  egSentenceKw: 'Mwen ka mandé tout sé bagay sala an non Jézi Kwi, amèn.',
  egSentenceEn: 'I ask all of these things in the name of Jesus Christ, amen.',
  synonym: ['ensiswatil'],
  antonym: [null],
  etymology: '[< Eng. amen]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'an lo',
  partOfSpeech: null,
  definition: ['a lot'],
  egSentenceKw: 'La té ni an lo moun.',
  egSentenceEn: 'There were a lot of people.',
  synonym: ['an chay', 'an pil', 'tibwen'],
  antonym: [null],
  etymology: '[< Fr. guère]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'asiz',
  partOfSpeech: 'V',
  definition: ['to sit'],
  egSentenceKw: 'Vyé madanm sala toujou ka asiz anba pyé mango-a.',
  egSentenceEn: 'The old lady is always sitting under the mango tree.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. assise]',
  dialect: '🇱🇨',
  variant: ['asid'],
}, {
  word: 'adan',
  partOfSpeech: 'PREP',
  definition: ['in', 'inside'],
  egSentenceKw: 'I mété chèbon-an adan tèson-an.',
  egSentenceEn: 'He put the charcoal in the coalpot.',
  synonym: ['an', 'andidan'],
  antonym: ['dèwò'],
  etymology: '[< Fr. dans]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'adan',
  partOfSpeech: 'PREP',
  definition: ['out of', 'from'],
  egSentenceKw: 'I tiyé lajan\'y adan pòch li.',
  egSentenceEn: 'He took his money out of his pocket.',
  synonym: ['an', 'andidan'],
  antonym: ['dèwò'],
  etymology: '[< Fr. dans]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'akòdans',
  partOfSpeech: 'PREP',
  definition: ['according to', 'in accordance with'],
  egSentenceKw: 'Yo pa ka viv akòdans pawòl Bondyé.',
  egSentenceEn: 'They don\'t live according to God\'s word.',
  synonym: ['akòdans di', 'akòdans pou'],
  antonym: [null],
  etymology: '[< Fr. accorder]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'alapòté',
  partOfSpeech: 'PREP',
  definition: ['alongside', 'beside', 'next to'],
  egSentenceKw: 'Kon kannòt-la wivé alapòté tjé-a, péchè-a mawé kòd-la vitman.',
  egSentenceEn: 'When the boat arrived alongside the dock, the fisherman tied the rope quickly.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. à la portée]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'alimans',
  partOfSpeech: 'PREP',
  definition: ['beside'],
  egSentenceKw: 'Dé motoka-a alé alimans yonn a lòt.',
  egSentenceEn: 'The two cars ran side by side.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'an',
  partOfSpeech: 'PREP',
  definition: ['in', 'inside'],
  egSentenceKw: 'La té ni on poul an kay mwen mé i ja alé.',
  egSentenceEn: 'There was a fowl in my house but it is gone now.',
  synonym: ['adan', 'andidan'],
  antonym: ['dèwò'],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'an',
  partOfSpeech: 'PREP',
  definition: ['upon'],
  egSentenceKw: 'An ouvè zyé\'y, i chonjé.',
  egSentenceEn: 'Upon opening his eyes, he remembered.',
  synonym: ['adan', 'andidan'],
  antonym: ['dèwò'],
  etymology: '[< Fr. en]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'anba',
  partOfSpeech: 'PREP',
  definition: ['below', 'under'],
  egSentenceKw: 'Mété liv-la anba tab-la.',
  egSentenceEn: 'Put the book under the table.',
  synonym: [null],
  antonym: ['anlè-a la'],
  etymology: '[< Fr. en bas]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'anba',
  partOfSpeech: 'CONJ',
  definition: ['unless'],
  egSentenceKw: 'Anba ou asèpté Jézi kon sovè, ou kay pèd.',
  egSentenceEn: 'Unless you accept Jesus as savior, you\'ll be lost.',
  synonym: ['èksèpté'],
  antonym: [null],
  etymology: '[< Fr. en bas]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'andidan',
  partOfSpeech: 'PREP',
  definition: ['in', 'inside'],
  egSentenceKw: 'Kwab-la antwé andidan twou-a.',
  egSentenceEn: 'The crab entered the hole.',
  synonym: ['adan', 'an'],
  antonym: ['dèwò'],
  etymology: '[< Fr. an dedans]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'andidan',
  partOfSpeech: 'PREP',
  definition: ['out of', 'from'],
  egSentenceKw: 'Kwab-la sòti andidan twou-a',
  egSentenceEn: 'The crab came out of the hole.',
  synonym: ['adan', 'an'],
  antonym: ['dèwò'],
  etymology: '[< Fr. an dedans]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'andji',
  partOfSpeech: 'PREP',
  definition: ['instead of', 'rather than'],
  egSentenceKw: 'Pwan sa mwen andji sa ou-a.',
  egSentenceEn: 'Take mine instead of yours.',
  synonym: ['olyè', 'pito'],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'anho',
  partOfSpeech: 'PREP',
  definition: ['above', 'over'],
  egSentenceKw: 'I té asou masonn-an anho kouch-la.',
  egSentenceEn: 'It was on the wall above the bed.',
  synonym: [null],
  antonym: ['anba'],
  etymology: '[< Fr. en haut]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'anlè',
  partOfSpeech: 'PREP',
  definition: ['on', 'upon', 'on top of', 'atop'],
  egSentenceKw: 'Yo mété\'y anlè tab-la.',
  egSentenceEn: 'They put it upon the table.',
  synonym: ['asou'],
  antonym: [null],
  etymology: '[< Fr. en l\'air]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'anlè',
  partOfSpeech: 'PREP',
  definition: ['off', 'off of', 'from'],
  egSentenceKw: 'Yo tiyé\'y anlè tab-la.',
  egSentenceEn: 'They took it off the table.',
  synonym: ['asou'],
  antonym: [null],
  etymology: '[< Fr. en l\'air]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'anmitan',
  partOfSpeech: 'PREP',
  definition: ['in the middle of'],
  egSentenceKw: 'Nou wè\'y anmitan lawi-a.',
  egSentenceEn: 'We saw him in the middle of the street.',
  synonym: ['asou'],
  antonym: [null],
  etymology: '[< Fr. en l\'air]',
  dialect: '🇱🇨',
  variant: ['nanmitan'],
}, {
  word: 'anpami',
  partOfSpeech: 'PREP',
  definition: ['among'],
  egSentenceKw: 'I té ka séwé anpami sé moun-an.',
  egSentenceEn: 'He was hiding among the people.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. en parmi]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'ant',
  partOfSpeech: 'PREP',
  definition: ['between'],
  egSentenceKw: 'Mété\'y ant sé liv-la.',
  egSentenceEn: 'He was hiding among the people.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. en parmi]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'antiwan',
  partOfSpeech: 'PREP',
  definition: ['except'],
  egSentenceKw: 'Ou sa pwan tout sé liv-la antiwan sala.',
  egSentenceEn: 'You can take all the books except this one.',
  synonym: ['èksèpté'],
  antonym: [null],
  etymology: '[< Fr. en tirant]',
  dialect: '🇱🇨',
  variant: ['antiwans'],
}, {
  word: 'apwé',
  partOfSpeech: 'PREP',
  definition: ['after'],
  egSentenceKw: 'Yo antwé yonn apwé lòt.',
  egSentenceEn: 'They entered one after the other.',
  synonym: [null],
  antonym: ['avan'],
  etymology: '[< Fr. en après]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'apwé',
  partOfSpeech: 'CONJ',
  definition: ['then'],
  egSentenceKw: 'Apwé mwen kité doudou-a épi mwen fini èk kalité lavi sala.',
  egSentenceEn: 'Then I left the girlfriend and I finished with that kind of life.',
  synonym: [null],
  antonym: ['avan'],
  etymology: '[< Fr. en après]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'asou',
  partOfSpeech: 'PREP',
  definition: ['off', 'off of', 'from'],
  egSentenceKw: 'I tiwé\'y asou difé- a.',
  egSentenceEn: 'He took it off the fire.',
  synonym: ['anlè'],
  antonym: [null],
  etymology: '[< Fr. sur]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'asou',
  partOfSpeech: 'PREP',
  definition: ['toward'],
  egSentenceKw: 'Pyè maché asou\'y.',
  egSentenceEn: 'Peter walked toward him.',
  synonym: ['anlè'],
  antonym: [null],
  etymology: '[< Fr. sur]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'asou',
  partOfSpeech: 'PREP',
  definition: ['about', 'concerning'],
  egSentenceKw: 'Annou palé asou sa.',
  egSentenceEn: 'Let\'s talk about that.',
  synonym: ['konsèné'],
  antonym: [null],
  etymology: '[< Fr. sur]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'a',
  partOfSpeech: 'PREP',
  definition: ['at', 'on', 'to', '(usage limited only to a few specific phrases)'],
  egSentenceKw: [null],
  egSentenceEn: [null],
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. à]',
  dialect: '🇱🇨',
  variant: [null],
},
];
